import styled from 'styled-components';

export default styled.h3`
font-family: 'TiemposDisplay-Medium' !important;
font-size: 22px;
padding: 18px 0;
text-align:center;
margin-top: auto;
`;
